import React from 'react';
import { PORT_KIND_COLORS } from '../../utils/ports';

/** Matches `PortLayer` — circle + outward triangle. */
export const PortMarker: React.FC<{
  color: string;
  direction?: number;
  x: number;
  y: number;
  scale?: number;
}> = ({ color, direction = 90, x, y, scale = 1 }) => {
  const r = 4 * scale;
  const rad = (direction * Math.PI) / 180;
  const tipX = x + Math.cos(rad) * r * 2;
  const tipY = y + Math.sin(rad) * r * 2;
  const wing = r * 0.86;
  const px = Math.cos(rad + Math.PI / 2);
  const py = Math.sin(rad + Math.PI / 2);
  const points = [
    [tipX, tipY],
    [x + px * wing, y + py * wing],
    [x - px * wing, y - py * wing],
  ]
    .map(([px, py]) => `${px},${py}`)
    .join(' ');

  return (
    <g>
      <circle cx={x} cy={y} r={r} fill={color} stroke="#ffffff" strokeWidth={1.2 * scale} />
      <polygon points={points} fill={color} />
    </g>
  );
};

export const TOOL_PORT_KINDS = [
  { color: PORT_KIND_COLORS.LOAD, label: 'Load' },
  { color: PORT_KIND_COLORS.UNLOAD, label: 'Unload' },
] as const;

export const STOCKER_PORT_KINDS = [
  { color: PORT_KIND_COLORS.UNLOAD_RAW, label: 'Pick' },
  { color: PORT_KIND_COLORS.UNLOAD_FINISHED, label: 'Drop' },
] as const;
